<template>
  <div class="log">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">求职期望</span>
      </p>
      <p style="padding-right: 2rem;color: #FFFFFF " @click="delJobWanteder()">删除</p>
    </header>
    <div class="personalMain">
      <div class="inforName">
      <van-field
          v-model="data.expectposition"
          label="期望职位"
          placeholder="请输入"
          input-align="right"
        />
        <van-field
          v-model="data.workcity"
          label="期望城市"
          placeholder="请输入"
          input-align="right"
        />
      </div>
      <div class="inforNameQ" >
        <p class="inforNameTop" style="padding-left: 10px">期望薪资</p>
        <p >
          <van-dropdown-menu active-color="#000000" title="11111">
            <!--<van-dropdown-item v-model="data.expectsalary" :options="option1" active-color="#000000"  placeholder="请选择"/>-->
            <van-dropdown-item v-model="data.expectsalary" :options="option1" active-color="#000000" :value="option1.value"  placeholder="请选择"/>
          </van-dropdown-menu>
        </p>
      </div>
    </div>
    <div class="button">
      <van-button style="width: 100%;margin: 0 auto" type="primary" @click="saveJobWanteder()">保存</van-button>
    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: "",
        data:{
          expectposition:"",
          workcity:'',
          expectsalary:"",
        },
        value1: 0,
        value2: 'a',
        option1: [
          { text: '请选择', value: 0 },
          { text: '1000-2000元/月', value: 1 },
          { text: '2000-4000元/月', value: 2 },
          { text: '4000-6000元/月', value: 3 },
          { text: '6000-8000元/月', value: 4 },
          { text: '8000-10000元/月', value: 5 },
          { text: '10000-15000元/月', value: 6 },
          { text: '15000-20000元/月', value: 7 },
          { text: '20000-25000元/月', value: 8 },
          { text: '25000-35000元/月', value: 9 },
          { text: '35000-50000元/月', value: 10 },
          { text: '50000-70000元/月', value: 11 },
          { text: '70000-100000元/月', value: 12 },
          { text: '100000元/月以上', value: 13 },
        ],
        option2: [
          { text: '默认排序', value: 'a' },
          { text: '好评排序', value: 'b' },
          { text: '销量排序', value: 'c' },
        ],
      }
    },
    mounted(){
//      this.saveJobWanteder()
      this.getJobWanteder()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      getJobWanteder(){
        console.log(this.$route.query.id)
        this.$api.getJobWanted({
          "id":this.$route.query.id,

        }).then(res=>{
          if(res.status==200){
           this.data=res.data[0]
          }
        }).catch(err=>{
        })
      },
      saveJobWanteder(){
        console.log(this.$route.params.id)
        this.$api.saveJobWanted({
          "id":this.$route.params.id,
//          "data[resumeid]":this.$route.params.id,
          "data[resumeid]":this.$route.query.id,
        "data[expectposition]": this.data.expectposition,
//        "data[expectsalary]": this.expectsalary,
        "data[expectsalary]": this.data.expectsalary,
        "data[workcity]": this.data.workcity
        }).then(res=>{
//          this.$router.push("/editResume")
          if(res.status==200){
//            this.data=res.data[0]
            this.$router.push(
//              {path:`/jobWanted/${this.$route.params.id}`}

            )
          }
        }).catch(err=>{
        })
      },
      delJobWanteder(){
        console.log(this.$route.params.id)
        this.$api.delJobWanted({
          "id":this.$route.query.id,
        }).then(res=>{
          if(res.status==200){
            this.$toast("删除成功")
            this.$router.push("/jobWanted")
          }
        }).catch(err=>{
        })
      },
    }
  }
</script>
<style scoped>
  header{
    width: 100%;
    height: 85px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .personalMain{
    /*padding-top: 82px;*/
    padding: 8rem 18px 0 18px;
  }
  .inforNameQ{
    border-bottom: solid 1px #DEDEDE;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;
  }
  .inforName input{
    border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  /*.inforName :first-child{*/
  /*font-size: 13px;*/
  /*}*/
  .inforNameTop{
    font-size: 13px;
    /*color: grey;*/
    padding-left: 10px;
  }
  .inforTime{
    width: 43%;
    text-align: center;
  }
  /deep/  .van-dropdown-menu__bar{
    box-shadow: 0 2px 12px rgba(0,0,0,.0)
  }
  .button{
    position: fixed;
    bottom: 0;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/jobWanteDetails.vue